import React from 'react';
import {connect, ConnectedProps} from 'react-redux';
import {RootState} from 'app/rootReducer';
import {fetchImages} from './imageListSlice';
import {Route, RouteComponentProps} from 'react-router';
import {GetImagesParams} from 'api';
import {Col, Row} from 'reactstrap';
import ImageTile from './ImageTile';
import {ImagesRoute, imagesRoute, imagesPath} from 'app/appRoutes';
import PaginationBar from 'features/shared/PaginationBar';
import HwImageModalContainer from './imageModal/HwImageModalContainer';

type Props = ConnectedProps<typeof connector>;

class ImageListPage extends React.Component<Props> {

    async componentDidMount() {
        const {images} = this.props;
        if (!images || !images.length){
            await this.loadImages();
        }
    }
    
    async componentDidUpdate(prevProps: Readonly<Props>) {
        const prevPage = prevProps.match.params.page;
        const currPage = this.props.match.params.page;
        if (prevPage !== currPage) {
            await this.loadImages();
            //window.scrollTo(0,0);
        }
    }

    async loadImages() {
        const {fetchImages, match: {params}} = this.props;
        const request: GetImagesParams = {
            filterId: params.filterId,
            filterReviewedAfter: parseInt(params.reviewedAfter) || 0,
            page: parseInt(params.page) || 0
        };
        await fetchImages(request);
    }

    renderImages() {
        const {images, fetchingImages} = this.props;
        return !images || !images.length 
            ? null 
            : images.map((x, i) => <ImageTile image={x} key={i} idx={i} fetchingImages={fetchingImages} />);
    }
    
    render() {
        const {pageCount, match: {params}} = this.props;
        const getRoute = (pageNum: number) => 
            imagesRoute(params.filterId, parseInt(params.reviewedAfter) || 0, pageNum - 1);

        return <>
            <Row>
                <Col md={12} className="d-flex flex-wrap">
                    {this.renderImages()}
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <PaginationBar params={params} pageCount={pageCount} getRoute={getRoute} />
                </Col>
            </Row>
            {this.props.match.params.imageIdx !== undefined && <Route path={imagesPath} component={HwImageModalContainer}/>}
        </>;
    }
}

const mapStateToProps = (state: RootState, ownProps: RouteComponentProps<ImagesRoute>) => {
    return {
        ...state.imageList,
        ...ownProps,
        fetchingImages: state.api.loadingProcList.indexOf('fetchImages') > -1
    };
};
const mapDispatchToProps = {fetchImages};
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(ImageListPage);
